<template>
    <el-dialog :visible.sync="dialogVisible" class="server-upgrade-dialog" width="760px" append-to-body :close-on-press-escape="false" :close-on-click-modal="false" @close="cancelUpgrade">
        <div class="server-upgrade-header">
            <p v-if="upgradeConfig.upgradeInfo === 'addSite'">
                温馨提示：您当前是
                <span>{{ '\“' + filterCombo.combo + '\”'}}</span>，最多只能创建
                <span>{{filterCombo.count}}个</span>站点
            </p>
            <p v-if="upgradeConfig.upgradeInfo === 'domain'">
                温馨提示：您当前是
                <span>{{ '\“' + filterCombo.combo + '\”'}}</span>，无法绑定域名和发布站点。
            </p>
            <p v-if="upgradeConfig.upgradeInfo === 'system1'">
                温馨提示：您当前是
                <span>{{ '\“' + filterCombo.combo + '\”'}}</span>，无法使用客服询盘。
            </p>
            <p v-if="upgradeConfig.upgradeInfo === 'system2'">
                温馨提示：您当前是
                <span>{{ '\“' + filterCombo.combo + '\”'}}</span>，无法使用流量统计。
            </p>
            <p v-if="upgradeConfig.upgradeInfo === 'space'">
                温馨提示：您当前是
                <span>{{ '\“' + filterCombo.combo + '\”'}}</span>，不支持独立虚机。
            </p>
        </div>
        <div class="server-upgrade-body">
            <div class="upgrade-body-left">
                <img src="../../assets/images/升级弹窗新_03.png" height="284" width="293" />
            </div>
            <div class="upgrade-body-right">
                <p>开通付费版本立即拥有</p>
                <ul>
                    <li>
                        <p>
                            <span></span>可发布1套网站1年（1个PC+1个手机）
                        </p>
                        <p>
                            <span></span>内含网站储存空间
                        </p>
                        <p>
                            <span></span>赠送网站备案服务
                        </p>
                        <p>
                            <span></span>赠送网络营销培训课程
                        </p>
                    </li>
                </ul>
            </div>
        </div>

        <span slot="footer" class="dialog-footer">
            <button class="button-action" @click="upgradeServer">
                <img src="../../assets/images/升级按钮新_03.png" height="50" width="190" />
            </button>
            <button class="button-cancel" @click="cancelUpgrade">取消</button>
        </span>
    </el-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import MemberApi from '@/api/member.api'
export default {
    name: 'ServiceUpgradeDialog',
    props: {
        upgradeConfig: {
            type: Object,
            default: function () {
                return {
                    show: false,
                    upgradeInfo: 'system2'
                }
            }
        }
    },
    data () {
        return {

        }
    },
    created () {
        this.dialogVisible = this.upgradeConfig.show
    },
    computed: {
        ...mapGetters('templateConfig', ['filterCombo']),
        ...mapGetters('user', ['userInfo']),
    },
    methods: {
        ...mapActions('member', ['authorizeNewNSY']),
        async upgradeServer () {

            // 站神购买页
            const parmas = {
                route: '/floor/Manager?goods_id=661&cat_id=216',
                type: '0',
            }
            const data = await this.authorizeNewNSY(parmas)
            if (data.isSuccess) {
                window.open(data.nswUrl)
            } else {
                this.$message.error('授权登陆失败')
            }
            // let { data } = await MemberApi.authorizeNswYun({ clientId: 'nswyun-client' })
            // if (data.isSuccess) {
            //     let url = `${data.data.nswyunUrl}&type=3&id=15`
            //     window.open(url)
            // } else {
            //     this.$message.error('授权登陆失败')
            // }
        },
        cancelUpgrade () {
            this.$parent.cancelUpgrade()
        }
    }
}

</script>

<style scoped lang="scss">
.server-upgrade-dialog {
    .server-upgrade-header {
        p {
            height: 86px;
            line-height: 86px;
            font-size: 20px;
            color: #666;

            span {
                color: #fd4a00;
            }
        }
    }

    .server-upgrade-body {
        display: flex;

        .upgrade-body-right {
            margin-left: 39px;
            width: 363px;

            p {
                height: 33px;
                line-height: 33px;
                color: #357ffe;
                font-size: 28px;
                white-space: nowrap;
            }

            ul {
                padding-top: 13px;

                li {
                    p {
                        font-size: 20px;
                        color: #333;
                        line-height: 50px;
                        height: 50px;

                        span {
                            display: inline-block;
                            width: 6px;
                            height: 6px;
                            background-color: #333;
                            border-radius: 50%;
                            margin-right: 10px;
                            vertical-align: middle;
                        }
                    }
                }
            }
        }
    }

    button {
        height: 50px;
        border-radius: 25px;
        width: 192px;

        &.button-action {
            vertical-align: bottom;
            color: #fff;
            font-size: 24px;
            margin-right: 50px;
            border: none;
        }

        &.button-cancel {
            vertical-align: bottom;
            color: #5c6c7c;
            font-size: 24px;
            border: 1px solid #c0c0c0;
            background-color: #f6f7f9;
        }
    }
}
</style>
